import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const addVote = async (choice: string) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.pollChoices.vote(choice));
